import { useState, useEffect } from 'react';
import { getAnonymousId, hasVotedInPoll } from '../utils/anonymousId';

export function useLocalUser() {
  const [userId] = useState<string>(getAnonymousId);

  return { 
    userId,
    hasVotedInPoll
  };
}